import api from "@/lib/api";

export async function downloadFile(request, fallbackName) {
  const res = await api({ ...request, responseType: "blob" });
  const match = /filename="?([^";]+)"?/.exec(res.headers["content-disposition"] || "");
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = match ? match[1] : fallbackName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export async function openPdf(request) {
  const res = await api({ ...request, responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  window.open(url, "_blank", "noopener");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
